var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccidente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#FFF0DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9789 36.6328C54.4042 35.5672 54.5286 35.7782 36.3592 35.7782C30.0954 35.7782 25 40.8304 25 47.0401V64.2682C25 68.6875 30.328 70.9377 33.5411 67.9681V71.9222C33.5411 72.3711 33.9035 72.7335 34.3524 72.7335H56.5895C57.0384 72.7335 57.4008 72.3711 57.4008 71.9222V60.9686H59.3968C61.9337 60.9686 64 58.9186 64 56.3979V47.0455C64 42.4639 61.2413 38.3746 56.9789 36.6383V36.6328ZM62.3773 56.3925C62.3773 58.0206 61.0412 59.3405 59.3968 59.3405H57.482V38.6775C60.4895 40.3706 62.3773 43.5295 62.3773 47.0347V56.3871V56.3925ZM55.7781 71.1054H35.1638V51.6919C35.1638 50.6209 33.5411 50.6209 33.5411 51.6919V64.2682C33.5411 66.1722 31.9832 67.6922 30.0792 67.6922C28.1752 67.6922 26.6173 66.156 26.6173 64.2682V47.0401C26.6173 41.7229 30.9825 37.4009 36.3538 37.4009H49.1356L46.5663 50.8806H43.6724C40.8705 50.8806 38.5932 53.1416 38.5932 55.9273C38.5932 58.713 40.8705 60.974 43.6724 60.974C44.116 60.974 44.2566 60.974 55.7781 60.974V71.1162V71.1054ZM55.8538 37.9419V59.3459H46.5988L50.7854 37.4009C52.5596 37.4009 54.0309 37.3036 55.8538 37.9419ZM44.9436 59.3459H43.667C41.763 59.3459 40.2105 57.8097 40.2105 55.9219C40.2105 54.0341 41.763 52.4979 43.667 52.4979H46.2039L44.9381 59.3405L44.9436 59.3459Z",
    fill: "url(#paint0_linear_204_15345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 34.1592C49.8226 34.1592 54.1499 29.8589 54.1499 24.5796C54.1499 19.3003 49.8226 15 44.5 15C39.1774 15 34.8447 19.3003 34.8447 24.5796C34.8447 29.8589 39.1774 34.1592 44.5 34.1592ZM52.5272 24.5796C52.5272 28.9664 48.9247 32.5365 44.5 32.5365C40.0753 32.5365 36.4674 28.9664 36.4674 24.5796C36.4674 20.1928 40.0699 16.6227 44.5 16.6227C48.9301 16.6227 52.5272 20.1928 52.5272 24.5796Z",
    fill: "url(#paint1_linear_204_15345)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_15345",
    x1: 44.5,
    y1: 35.7612,
    x2: 44.5,
    y2: 72.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3663D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_15345",
    x1: 44.4973,
    y1: 15,
    x2: 44.4973,
    y2: 34.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3663D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccidente);
export default __webpack_public_path__ + "static/media/Accidente.47270ddb0bac1d3c384ea2bc326b2a6a.svg";
export { ForwardRef as ReactComponent };